import { useMemo } from "react";

export const useExportData = dataForExport => {
  const txtData = useMemo(
    () => dataForExport?.map(item => `${item.ip}:${item.port}`),
    [dataForExport],
  );

  const exportData = useMemo(
    () =>
      dataForExport
        ?.map(
          // eslint-disable-next-line no-useless-escape
          item => `<div style=\"padding: 5px;\">${item.ip}:${item.port}</div>`,
        )
        .join(" "),
    [dataForExport],
  );

  return {
    txtData,
    exportData,
  };
};
